export const clickOnKeyPress = (node: HTMLButtonElement, key: KeyboardEvent['key']) => {
  if (key === null) {
    return;
  }

  function handleKeydown(ev: KeyboardEvent) {
    if (ev.key === key) {
      // node.focus();
      node.classList.add('opacity-90');
    }
  }

  function handleKeyup(ev: KeyboardEvent) {
    if (ev.key === key) {
      node.click();
      node.classList.remove('opacity-90');
    }
  }

  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('keyup', handleKeyup);

  return {
    destroy() {
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('keyup', handleKeyup);
    }
  };
};
